// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "video[data-v-d871e866]{outline:none}video[poster][data-v-d871e866]{-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
